<template>
  <div class="container">
    <div>
      <van-nav-bar
        :title="accountTitle"
        left-arrow
        @click-left="onClickLeft"
        style="margin-bottom: 1vw"
      />

      <van-cell-group class="group">
        <van-field
          v-if="this.form.bankType == 2"
          placeholder="姓名"
          label="姓名"
          v-model="form.nickName"
          clearable
          label-width="70px"
        />
        <van-field
          v-if="this.form.bankType == 1"
          placeholder="个体公司全称"
          label="公司全称"
          v-model="form.nickName"
          clearable
          label-width="70px"
        />
        <van-field
          v-if="this.form.bankType == 1"
          placeholder="银行卡号"
          label="账号"
          v-model="form.bankNumber"
          type="digit"
          clearable
          label-width="70px"
        />
        <van-field
          v-if="this.form.bankType == 2"
          placeholder="身份证"
          label="身份证"
          v-model="form.userCard"
          clearable
          label-width="70px"
        />
        <van-field
          v-model="form.openingBank"
          is-link
          label="开户银行"
          placeholder="开户银行"
          label-width="70px"
          readonly
          @click="showBank = true"
        />
        <van-field
          v-if="this.form.bankType == 2"
          placeholder="银行卡号"
          label="银行卡号"
          v-model="form.bankNumber"
          type="digit"
          clearable
          label-width="70px"
        />
        <!-- <van-field
          v-if="this.form.bankType == 2"
          placeholder="测试"
          label="请输入"
          v-model="form.aaa"
          clearable
          label-width="70px"
        />
        <ul
          style="
            width: 200px;
            height: 100px;
            overflow: auto;
            border: 1px solid #f1f1f1;
            position: fixed;
            z-index: 2;
            background: #fff;
            margin-left: 100px;
            padding-left: 15px;
          "
        >
          <li
            v-for="item in searchData"
            :key="item.vaule"
            style="
              width: 100%;
              height: 50px;
              line-height: 50px;

              border-bottom: 1px solid #fafafa;
            "
            @click="searchDataChange(item)"
          >
            {{ item.text }}
          </li>
        </ul> -->

        <!-- <van-popup v-model="showBank" round position="bottom">
        <van-picker
          title="选择银行"
          show-toolbar
          :columns="searchData"
          v-model="form.bank"
          @cancel="showBank = false"
          @confirm="Confirm"
        />
      </van-popup> -->
        <!-- <van-action-sheet v-model="showBank" title="银行">
          <div class="content">
            <van-field v-model="search" placeholder="请输入银行" clearable />
            <ul style="margin-top: 50px; height: 160px">
              <li
                v-for="item in searchData"
                :key="item.vaule"
                style="
                  width: 100%;
                  height: 50px;
                  line-height: 50px;
                  text-align: center;
                  border-bottom: 1px solid #fafafa;
                "
                @click="searchDataChange(item)"
              >
              <input type="text" />
                {{ item.text }}
              </li>
            </ul>
          </div>
        </van-action-sheet> -->
      </van-cell-group>
      <van-field
        v-if="this.form.bankType == 2"
        v-model="form.bankInfo"
        placeholder="开户银行信息"
        label="开户信息"
        rows="2"
        autosize
        type="textarea"
        maxlength="200"
        show-word-limit
        clearable
        label-width="70px"
      />
    </div>
    <van-popup v-model="showBank" round position="bottom">
      <van-field
        left-icon="search"
        label="银行"
        label-width="60px"
        v-model="form.openingBank"
        placeholder="请输入银行"
        clearable
      />
      <van-picker
        title="选择银行"
        v-model="form.openingBank"
        show-toolbar
        :columns="searchData"
        @confirm="onData"
        @cancel="onCancel"
      />
    </van-popup>
    <div class="bottom" @click="onSubmit(form)">
      <!-- <div class="binding">
        <span class="tips">提示：</span>要绑定银行卡号和个人信息才能发工资
      </div> -->
      <button class="button">立即绑定</button>
    </div>
  </div>
</template>
<script>
import {
  CellGroup,
  Form,
  Field,
  Notify,
  Button,
  DatetimePicker,
  Popup,
  Toast,
  Picker,
  Dialog,
  Search,
  ActionSheet,
  NavBar,
} from "vant";
import { list } from "../../../util/bank";
import { mapGetters, mapActions } from "vuex";
import service from "../../../api/bank/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
    [Dialog.name]: Dialog,
    [Search.name]: Search,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      accountTitle: "", //
      showBank: false,
      bankList: [],
      name: "",
      form: {
        bankType: 0,
        nickName: "",
        openingBank: "",
        bankNumber: "",
        userCard: "",
        bankInfo: "",
      },
      showmode: true,
      isShow: false,
      showGender: false,
      showPicker: false,
      columns: [], //获取银行信息,
      searchText: "",
      search: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),

    searchData: function () {
      var search = this.form.openingBank;
      // var search = this.form.aaa;
      var searchVal = ""; //搜索后的数据
      if (search) {
        searchVal = list.filter(function (product) {
          return Object.keys(product).some(function (key) {
            //搜索所有的内容
            return String(product[key]).toLowerCase().indexOf(search) > -1;
            //只搜索问题内容（某一个key）
            // return (
            //   String(product["questions"]).toLowerCase().indexOf(search) > -1
            // );
          });
        });
        return searchVal;
      } else {
        searchVal = list;
        return searchVal;
      }
    },
  },
  mounted() {
    this.bankList = list;
    this.form.bankType = JSON.parse(this.$route.query.type);
    if (this.form.bankType == 1) {
      this.accountTitle = "绑定个体工商户卡";
    }
    if (this.form.bankType == 2) {
      this.accountTitle = "绑定个人银行卡";
    }
  },
  methods: {
    ...mapActions(["saveBankStatus"]),
    onClickLeft() {
      this.$router.go(-1);
    },
    searchDataChange(item) {
      this.search = item.text;
      console.log(this.search, 227);
    },
    onConfirm(value) {
      this.form.bank = value.text;
      this.showPicker = false;
    },
    Confirm(value) {
      this.form.sex = value;
      this.showBank = false;
    },
    onData(value) {
      console.log(value, 305);
      if (value == undefined) {
        Toast("请匹配正确的开户银行");
        return;
      }
      this.form.openingBank = value.text;
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
      this.form.openingBank = "";
    },
    onSubmit(form) {
      var search = this.searchData.find((i) => this.form.openingBank == i.text);
      // this.form.openingBank = this.search;
      // var idCard = /[^a-zA-Z0-9]/g
      var idCard = /[^0-9Xx]/g;

      if (this.form.nickName.trim() == "") {
        Notify({ type: "danger", message: "请输入姓名" });
        return;
      }
      if (this.form.bankType == 2) {
        if (this.form.nickName.length > 16) {
          Notify({ type: "danger", message: "姓名过长，请修改正确的姓名" });
          return;
        }
        if (this.form.userCard.trim() == "") {
          Notify({ type: "danger", message: "请输入身份证号码" });
          return;
        }
        if (this.form.userCard.length > 30 || idCard.test(this.form.userCard)) {
          Notify({ type: "danger", message: "请输入正确的身份证号码" });
          return;
        }

        if (this.form.bankInfo.trim() == "") {
          Notify({ type: "danger", message: "请输入开户银行信息" });
          return;
        }
      }
      if (this.form.bankNumber.length <= 0) {
        Notify({ type: "danger", message: "请输入正确的银行卡号" });
        return;
      }
      if (this.form.bankNumber.length > 50) {
        Notify({ type: "danger", message: "请输入正确的银行卡号" });
        return;
      }
      if (this.form.openingBank.trim() == "") {
        Notify({ type: "danger", message: "请选择开户银行" });
        return;
      }
      if (search == undefined) {
        Notify({ type: "danger", message: "请匹配正确的开户银行" });
        return;
      }
      console.log(this.form.bankInfo, this.form.name, 168);

      Dialog.confirm({
        message: "请确认好自己的个人信息，如果信息错误工资将不能正常发放",
      })
        .then(() => {
          // on confirm
          service
            .addbankCard(this.form)
            .then((res) => {
              if (res.statusCode == 200) {
                Toast("绑定成功");
                this.$router.replace("addBankCard");
                let obj = {
                  save: true,
                  cardStatus: true,
                  color: this.form.bankType,
                };
                this.saveBankStatus(obj);
              } else {
                Toast(res.errors);
                Notify({
                  type: "danger",
                  message: res.errors,
                });
              }
            })
            .catch((err) => {
              if (err.status == 400) {
                this.$router.replace({
                  name: "invitationSuccess",
                  query: { status: false },
                });
                // Toast(err.data);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.container {
  // height: calc(100% - 46px);
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .binding {
    color: #919191;
    font-size: 3.2vw;
    text-align: center;
  }

  @{deep}.van-popup {
    .van-cell {
      align-items: center;
      line-height: normal;
      box-sizing: border-box;
      height: auto;
      padding: 3.4vw 4.26667vw;

      .van-field__control {
        height: 9vw;
        line-height: 9vw;
      }
    }
  }

  @{deep}.van-field__label {
    color: #000;
  }

  @{deep}.van-cell__title,
  .van-cell__value {
    flex: none;
    text-align: left;
  }

  .group {
    box-shadow: 0px 18px 23px 1px rgba(0, 0, 0, 0.03);

    .van-cell {
      // font-size: 4vw;
      // height: 14.4vw;
      // padding: 0 6vw;
      // line-height: 14.4vw;
      align-items: center;
      line-height: initial;
      padding: 3.4vw 4.26667vw;

      // @{deep}.van-field__label {
      //   color: #000;
      // }
      @{deep}.van-field__control {
        color: #919191;
        font-size: 4vw;
        height: 9vw;
      }

      @{deep}.van-cell__title,
      .van-cell__value {
        flex: none;
        text-align: left;
      }
    }
  }

  .bottom {
    margin: 0 auto 14.6vw;

    .button {
      width: 305px;
      height: 45px;
      border: 0;
      color: #fff;
      background: linear-gradient(0deg, #d8051d, #f5586b);
      border-radius: 21px;
      margin-top: 32px;
      border-radius: 1.6vw;
    }
  }
}
</style>
